import { IPriceMandantSettingsV2 } from "../types/article-price";

/**
 * Formats a numeric price according to the provided PriceMandantSettings:
 * - rounds to the desired decimal precision
 * - inserts group separators
 * - returns the resulting string (e.g. "1,578.12 �")
 */
export function formatPrice(priceValue: number, settings: IPriceMandantSettingsV2): string {
    const numericValue = parsePriceString(priceValue);

    const formattedPrice = formatNumericPrice(numericValue, settings);

    return addCurrencySymbols(formattedPrice, settings);
}

function parsePriceString(value: number): number {
    const normalized = value.toString().replace(/,/g, "");
    return Number(normalized);
}

function formatNumericPrice(value: number, settings: IPriceMandantSettingsV2): string {
    const rounded = Number(value.toFixed(settings.numberDecimalDigits));

    const [intRaw, fracRaw = ""] = rounded.toString().split(".");

    const reversed = intRaw.split("").reverse();
    const grouped: string[] = [];

    for (let i = 0; i < reversed.length; i++) {
        if (i > 0 && i % settings.numberGroupSizes === 0) {
            grouped.push(settings.numberGroupSeparator);
        }
        grouped.push(reversed[i]);
    }
    const intFormatted = grouped.reverse().join("");

    const fracPadded = fracRaw.padEnd(settings.numberDecimalDigits, "0");

    return `${intFormatted}${settings.numberDecimalSeparator}${fracPadded}`;
}

function addCurrencySymbols(formattedPrice: string, settings: IPriceMandantSettingsV2): string {
    return settings.prependCurrencySymbol
        ? `${settings.currencySymbol} ${formattedPrice}`
        : `${formattedPrice} ${settings.currencySymbol}`;
}
